import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const ChevronCloseDrawer: React.FC<NormalIconProps> = (props) => (
	<svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={props.onClick} className={props.className}>
		<path d="M15 1L8 7L1 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
